let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("14wFt")).then(() => parcelRequire('3cCIn'));